/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getDashboardDataQueryDaysDefault = 30;

export const getDashboardDataQueryParams = zod.object({
  "days": zod.number().default(getDashboardDataQueryDaysDefault)
})





export const getDashboardDataResponseSystemTemplatesItemPayRateValueMin = 0;
export const getDashboardDataResponseSystemTemplatesItemPayRateValueMax = 10000;

export const getDashboardDataResponseSystemTemplatesItemAddressAddressLine1Max = 255;

export const getDashboardDataResponseSystemTemplatesItemAddressAddressLine2Max = 255;

export const getDashboardDataResponseSystemTemplatesItemAddressCityMax = 255;

export const getDashboardDataResponseSystemTemplatesItemAddressStateMax = 2;

export const getDashboardDataResponseSystemTemplatesItemAddressZipMax = 10;

export const getDashboardDataResponseSystemTemplatesItemAddressCountryMax = 100;



export const getDashboardDataResponse = zod.object({
  "pendingPayCount": zod.number(),
  "topEarners": zod.array(zod.object({
  "name": zod.string().min(1),
  "earnings": zod.number()
})),
  "topClaimers": zod.array(zod.object({
  "name": zod.string().min(1),
  "claimCount": zod.number()
})),
  "systemTemplates": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid().nullish(),
  "scope": zod.enum(['System', 'Organization', 'Community']),
  "templateName": zod.string().min(1),
  "title": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(getDashboardDataResponseSystemTemplatesItemPayRateValueMin).max(getDashboardDataResponseSystemTemplatesItemPayRateValueMax).nullish()
}).optional(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(getDashboardDataResponseSystemTemplatesItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getDashboardDataResponseSystemTemplatesItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getDashboardDataResponseSystemTemplatesItemAddressCityMax).nullish(),
  "state": zod.string().max(getDashboardDataResponseSystemTemplatesItemAddressStateMax).nullish(),
  "zip": zod.string().max(getDashboardDataResponseSystemTemplatesItemAddressZipMax).nullish(),
  "country": zod.string().max(getDashboardDataResponseSystemTemplatesItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish()
}))
})

